module.exports = [{
      plugin: require('C:/Users/KwS/dev/site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
